import Vue from 'vue'
import './Filter/dateTime'
import VueRouter from 'vue-router'
import router from './router/routers'
import store from './store/store'
import Vuetify from 'vuetify'
import App from './App.vue'

import './bootstrap'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Vuetify)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
